import { hexToRgba } from "pages/labelerVideo/utils/hexToRgba";

export const PREDICTION_FILL_OPACITY = 0.35;

export const PREDICTION_STRIPE_PERIOD = 8;

export const PREDICTION_STRIPE_BACKGROUND_IMAGE =
  "repeating-linear-gradient(-45deg, transparent, transparent 4px, rgba(0, 0, 0, 0.08) 4px, rgba(0, 0, 0, 0.08) 8px)";

export const getPredictionFillColor = (hexColor: string) =>
  hexToRgba(hexColor, PREDICTION_FILL_OPACITY);
